'use client';

import { createContext, useContext, useRef, type RefObject } from 'react';

type GlobalLayoutContextType = {
  spaNavigationStart: RefObject<number | null>;
};

const GlobalLayoutContext = createContext<GlobalLayoutContextType>({
  spaNavigationStart: { current: null }
});

export function GlobalLayoutProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const spaNavigationStart = useRef<number | null>(null);

  return (
    <GlobalLayoutContext.Provider value={{ spaNavigationStart }}>
      {children}
    </GlobalLayoutContext.Provider>
  );
}

GlobalLayoutProvider.displayName = 'GlobalLayoutProvider';

export function useSpaNavigationTiming() {
  return useContext(GlobalLayoutContext).spaNavigationStart;
}
